const SIK_EUROPE = "https://sik.search.blue.cdtapps.com";
const SIK_COWORKER = "https://coworker.search.blue.cdtapps.com";
const SIK_CHINA = "https://search.ikea.cn";

export const sikBaseUrlCoworker = window.location.host.includes(".cn")
  ? SIK_CHINA
  : SIK_COWORKER;

export const sikBaseUrl = window.location.host.includes(".cn")
  ? SIK_CHINA
  : SIK_EUROPE;
export const SIK_AUTOCOMPLETE = "search-box";
export const SIK_SEARCH = "search-result-page";
export const SIK_SEARCH_MORE = "search-result-page/more";
export const RESULT_LIMIT_PER_PAGE = "10";
export const ItemNoRegex =
  /^\s*(?:s|ART|SPR)\s*(\d\d\d)\.?(\d\d\d)\.?(\d\d)\s*/;
